export default __webpack_public_path__ + "static/media/LDREdited.18d1749e.webp";